<template>
  <div class="cus-textarea">
    <a-textarea v-bind="{ ...$attrs }" />
  </div>
</template>
<script setup></script>
<style scoped lang="scss">
.cus-textarea {
  ::v-deep(.ant-input-textarea) {
    background: rgba(216, 216, 216, 0.2);
    border-radius: 4px;
    .ant-input {
      border: none;
      background-color: transparent;
      padding: 8px;
      &:focus {
        border: none;
        box-shadow: none;
      }
    }
  }
}
</style>
